
import UrlBuilder from "./UrlBuilder";
import { API_ENDPOINTS } from "./Endpoints"; 

const app_api_url = import.meta.env.VITE_APP_API_URL;
//const urlBuilder = new UrlBuilder(app_api_url);
const urlBuilder = new UrlBuilder(`${app_api_url}`);


class AuthHeaders {
    
    getHeaders(accessToken) {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json'); 
      if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
      }
      return headers;
    }
  }
  
  class ApiService {
    constructor(authHeaders, urlBuilder, endpoints) {
      this.authHeaders = authHeaders;
      this.urlBuilder = urlBuilder;
      this.endpoints = endpoints;
    }
  
   

    async get(endpointKey, accessToken, params) {
        const endpoint = typeof this.endpoints[endpointKey] === 'function' ? this.endpoints[endpointKey](params) : this.endpoints[endpointKey];
        const url = this.urlBuilder.buildUrl(endpoint);
        if (process.env.NODE_ENV === 'development') {
          console.log(`GET request to: ${url}`);
          console.log("GET params:", params);
        }
        const response = await this.makeRequest('GET', url, accessToken);
        if (process.env.NODE_ENV === 'development') {
          console.log("GET response:", response);  
        }
        return response;
        //return this.makeRequest('GET', url, accessToken);
      }

      
    async getX(endpointKey, xApiKey, params = null) {
      const endpoint = typeof this.endpoints[endpointKey] === 'function'
        ? this.endpoints[endpointKey](params)
        : this.endpoints[endpointKey];

      const url = this.urlBuilder.buildUrl(endpoint);
      console.log(`GET request to (x-api-key): ${url}`);

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('x-api-key', xApiKey); // Pasamos el x-api-key

      const response = await fetch(url, { method: 'GET', headers });

      if (!response.ok) {
        throw new Error(`Error en ApiService (x-api-key): ${response.status} - ${response.statusText}`);
      }

      return await response.json();
    }

    
      async post(endpointKey, accessToken, body, params) {
        const endpoint = typeof this.endpoints[endpointKey] === 'function' ? this.endpoints[endpointKey](params) : this.endpoints[endpointKey];
        const url = this.urlBuilder.buildUrl(endpoint);
        console.log(`POST request to: ${url}`);
        console.log("POST params:", params);
        console.log("POST body:", body);
        return this.makeRequest('POST', url, accessToken, body);
      }

      async postX(endpointKey, xApiKey, body = {}, params = null) {
        const endpoint = typeof this.endpoints[endpointKey] === 'function'
          ? this.endpoints[endpointKey](params)
          : this.endpoints[endpointKey];

        const url = this.urlBuilder.buildUrl(endpoint);
        console.log(`POST request to (x-api-key): ${url}`);
        console.log("POSTX params:", params);
        console.log("POSTX body:", body);

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('x-api-key', xApiKey);

        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          throw new Error(`Error en ApiService postX (x-api-key): ${response.status} - ${response.statusText}`);
        }

        return await response.json();
      }
    
      async put(endpointKey, accessToken, body, params) {
        const endpoint = typeof this.endpoints[endpointKey] === 'function' ? this.endpoints[endpointKey](params) : this.endpoints[endpointKey];
        const url = this.urlBuilder.buildUrl(endpoint);
        console.log(`PUT request to: ${url}`);
        console.log("PUT params:", params);
        console.log("PUT body:", body);
        const response = await this.makeRequest('PUT', url, accessToken, body);

        console.log("PUT response:", response);
        return response;
        //return this.makeRequest('PUT', url, accessToken, body);
      }
    
      async delete(endpointKey, accessToken, params) {
        const endpoint = typeof this.endpoints[endpointKey] === 'function' ? this.endpoints[endpointKey](params) : this.endpoints[endpointKey];
        const url = this.urlBuilder.buildUrl(endpoint);
        return this.makeRequest('DELETE', url, accessToken);
      }
  
    async makeRequest(method, url, accessToken, body) {
      try {
        const headers = this.authHeaders.getHeaders(accessToken);
        const options = {
          method,
          headers,
        };
  
        if (body) {
          options.body = JSON.stringify(body);
          console.warn("Cuerpo del body:" + options.body);
        }
  
        const response = await fetch(url, options);
        //console.warn("texto del response:"+JSON.stringify(response));
  
        if (!response.ok) {
          throw new Error(`Error en ApiService: ${response.status} - ${response.statusText}`);
        }
  
        return await response.json();
      } catch (error) {
        console.error(`Error al hacer la solicitud (${method}):`, error);
        
        throw error;
      }
    }
  }
  
 
  export const apiService = new ApiService(new AuthHeaders(), urlBuilder, API_ENDPOINTS);



   // async get(endpoint, accessToken) {
    //   const url = this.urlBuilder.buildUrl(endpoint);
    //   return this.makeRequest('GET', url, accessToken);
    // }
  
    // async post(endpoint, accessToken, body) {
    //   const url = this.urlBuilder.buildUrl(endpoint);
    //   return this.makeRequest('POST', url, accessToken, body);
    // }
  
    // async put(endpoint, accessToken, body) {
    //   const url = this.urlBuilder.buildUrl(endpoint);
    //   console.warn("Body antes del PUT: "+JSON.stringify(body))
    //   return this.makeRequest('PUT', url, accessToken, body);
    // }
  
    // async delete(endpoint, accessToken) {
    //   const url = this.urlBuilder.buildUrl(endpoint);
    //   return this.makeRequest('DELETE', url, accessToken);
    // }